module.exports = __webpack_public_path__ + "fonts/voicecall_70x70.b651a1f230ee1aea148c87773d533faf.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/voicecall_70x70.png
// module id = 800
// module chunks = 9